


































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {mapState} from "vuex";
import {User} from "@/params/User";

@Component({
  computed: mapState([ 'user' ])
})
export default class AppUserUnit extends Vue {

  protected user: User;

  @Prop() dark: boolean;
  @Prop() avatarSize: number;
  @Prop() useLogout: boolean;
  @Prop() hideUserName: boolean;
  @Prop() useRightBorder: boolean;

  /**
   * ユーザーのサムネイル写真のURLを取得
   */
  get userThumbnailUrl (): string {
    if (this.user) {
      // ゲストユーザーの時
      if (this.user.isGuest) {
        return this.$store.getters.guestUserIcon;
      }
      // サムネイル写真が取得できた時
      if (this.user.thumbnailUrl && this.user.thumbnailUrl !== '') {
        return this.user.thumbnailUrl;
      }
      // サムネイル写真が存在しない時
      else {
        return this.$store.getters.noImageUserIcon;
      }
    }
    else {
      // ユーザーデータが存在しない場合もnoImage状態にする
      return this.$store.getters.noImageUserIcon;
    }
  }

  /**
   * スマートフォンレイアウトかどうか
   */
  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  /**
   * ログアウトボタンを押した時のイベントリスナー
   * @param ev
   */
  @Emit('logout')
  protected onClickLogout (ev: MouseEvent): void {}

}
